<dx-popup title="Rentals" [width]="1000" [height]="800" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
  <dx-data-grid
    #customerRentalsGrid
    keyExpr="id"
    class="d-flex flex-fill flex-column"
    [dataSource]="rentals"
    [height]="'400px'"
    [showBorders]="true"
    style="min-height: 650px; min-width: 750px"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    >
    <dxi-data-grid-column dataField="id" caption="Id" width="75" cellTemplate="linkTemplate"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="price" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="startDate" width="100"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="endDate" width="100"></dxi-data-grid-column>
    <dxi-data-grid-column dataField="margin" width="100" [format]="{ type: 'percent', precision: 0 }"></dxi-data-grid-column>
    <dxi-data-grid-column></dxi-data-grid-column>

    <div *dxTemplate="let cell of 'linkTemplate'">
      @if (cell.data) {
        <a [routerLink]="[]" (click)="open(cell.data)">{{ cell.text }}</a>
      }
    </div>
    <div *dxTemplate="let data of 'toolbarButtons'"></div>
    <div *dxTemplate="let data of 'toolbarText'">
      <span class="me-3">
        <strong>{{ customerRentalsGrid.instance.totalCount() + ' items' }}</strong>
      </span>
    </div>
    <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
  </dx-data-grid>
</dx-popup>
